<script setup lang="ts">
import { useOverlay } from '../../composables/useOverlay';
import FocusLock from 'vue-focus-lock';

const overlay = useOverlay();

function onEsc() {
  overlay.closeModal(null);
}

function onOutsideClick() {
  overlay.closeModal(null);
}
function handleModalClose(result: unknown) {
  overlay.closeModal(result);
}
</script>

<template>
  <Teleport to="body">
    <TransitionGroup
      name="fade"
      tag="div"
    >
      <div
        v-for="(modal, index) in overlay.modals"
        :key="index"
        class="fixed bg-black/60 flex justify-center items-center z-9999999 inset-0 backdrop-blur-xs px-4"
        tabindex="0"
        @click.self="onOutsideClick"
        @keydown.esc="onEsc"
      >
        <FocusLock>
          <div
            class="bg-yellow-200 rounded-xl p-6 max-w-2xl w-full shadow-xl overflow-y-auto max-h-[90vh]"
            role="dialog"
            aria-modal="true"
          >
            <component
              :is="modal.component"
              v-bind="modal.props || {}"
              @close="handleModalClose"
            />
          </div>
        </FocusLock>
      </div>
    </TransitionGroup>
  </Teleport>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(30px); }
</style>
